"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetGroupClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class WidgetGroupClient extends authenticated_client_1.AuthenticatedClient {
    getAll(projectId, dashboardId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/dashboards/${dashboardId}/widget-groups`);
            return response.payload;
        });
    }
    bulkCreate(projectId, dashboardId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards/${dashboardId}/widget-groups`, payload);
            return response.payload;
        });
    }
    bulkUpdate(projectId, dashboardId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/dashboards/${dashboardId}/widget-groups`, payload);
            return response.payload;
        });
    }
    clone(projectId, dashboardId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards/${dashboardId}/widget-groups/clone`, payload);
            return response.payload;
        });
    }
    move(projectId, dashboardId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards/${dashboardId}/widget-groups/move`, payload);
            return response.payload;
        });
    }
    bulkDelete(projectId, dashboardId, ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/users/me/dashboards/${dashboardId}/widget-groups?` + this.getQueryString({ id: ids }));
            return response.payload;
        });
    }
}
exports.WidgetGroupClient = WidgetGroupClient;
//# sourceMappingURL=widget-group.client.js.map